/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ShallowContactFromJSON, ShallowContactToJSON } from './ShallowContact';
export function CreateWithEmailAddressContactResponseDataFromJSON(json) {
    return CreateWithEmailAddressContactResponseDataFromJSONTyped(json, false);
}
export function CreateWithEmailAddressContactResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contact: !exists(json, 'contact') ? undefined : ShallowContactFromJSON(json['contact'])
    };
}
export function CreateWithEmailAddressContactResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact: ShallowContactToJSON(value.contact)
    };
}
